<template>
  <transition name="slide-fade">
    <div class="otc-box">
      <h3 :class="{'red':!buy,'green':buy}">{{buy?'خرید':'فروش'}}</h3>
      <pay-otc-modal v-if="payModal === true" @close="payModal = false" @choise='choiseCoin'/>
      <resive-otc-modal v-if="resiveModal === true" @close="resiveModal = false" @resivecoin='resivecoin'/>
      <div class="value-section">
        <span v-if="state.token"> موجودی شما :</span>



        <span style="cursor: pointer" v-if="state.token" > {{ buy? $toLocal(BuywalletBalance.credit, $decimal["TOMAN"])
            : $toLocal(credit, $decimal[coin]) }}  <small v-if="state.token">{{buy?'تومان': $coins[coin].code}}</small>
      </span>


      </div>

      <div class="pay" v-if="buy">
        <div class="pay-section">
          <div class="pay-text">
            <span>مقدار پرداختی</span>
          </div>

          <div @click="payModal = true" class="pay-type">

            <img src="../../assets/icon/bottom-arrow.png" alt="">

            <span>{{ items.name }} ({{ items.relationName }})</span>
            <inline-svg :src="require('../../assets/coins/' + items.logo + '.svg')"/>
          </div>

        </div>
<div class="max">
  <button class="btn gray-btn" @click.prevent="setMax">Max</button>
  <input type="text" class="ex-input"               @input="inputsFun('totalPrice')"
         v-model="data.totalPrice" >

</div>
      </div>

      <div class="pay" v-if="!buy">
        <div class="pay-section">
          <div class="pay-text">
            <span>مقدار پرداختی</span>
          </div>

          <div @click="resiveModal = true" class="pay-type">
            <img src="../../assets/icon/bottom-arrow.png" alt="">
            <span>{{ resItem.persianName }} ({{ resItem.code }})</span>
            <img :src="require('../../assets/coins/' + resItem.code + '.png')" width="20"/>
          </div>

        </div>
        <div class="max">
          <button class="btn gray-btn" @click.prevent="setMaxAmount">Max</button>
          <input type="text" class="ex-input"               @input="inputsFun('totalPrice')"
                 v-model="data.amount" >

        </div>
      </div>

      <div class="resive-value">
<!--        <span>مقدار قابل ارائه</span>-->
<!--        <span>75,000 TMN</span>-->
      </div>

      <div class="change-icon transfer-logo" @click="buy = !buy" :class="{'mirror' : !buy}">
        <inline-svg :src="require('../../assets/icon/change.svg')"/>
      </div>

      <div class="resive-section">
        <div class="pay" v-if="buy">
          <div class="pay-section">
            <div class="pay-text">
              <span>مقدار دریافتی</span>
            </div>

            <div @click="resiveModal = true" class="pay-type">
              <img src="../../assets/icon/bottom-arrow.png" alt="">
              <span>{{ $coins[resItem.coin].persianName }} ({{ resItem.code }})</span>
              <img :src="require('../../assets/coins/' + resItem.code + '.png')" width="20"/>
            </div>

          </div>
          <input type="text" class="ex-input"      @input="inputsFun('amount')"
                 v-model="data.amount">
        </div>

        <div class="pay" v-if="!buy">
          <div class="pay-section">
            <div class="pay-text">
              <span>مقدار دریافتی</span>
            </div>

            <div @click="payModal = true" class="pay-type">

              <img src="../../assets/icon/bottom-arrow.png" alt="">

              <span>{{ items.name }} ({{ items.relationName }})</span>
              <inline-svg :src="require('../../assets/coins/' + items.logo + '.svg')"/>
            </div>

          </div>
          <input type="text" class="ex-input"               @input="inputsFun('totalPrice')"
                 v-model="data.totalPrice">
        </div>




        <div class="resive-value">
<!--          <span>مقدار قابل ارائه</span>-->
<!--          <span>75,000 TMN</span>-->
        </div>

      </div>

      <div class="submit">
        <div class="text" :key="coin + 'buy'">

        <div class="minmax">
          <span>میزان قابل ارائه:</span>
          <span>{{ `${minAmountExchange} (حداقل) ~ ${maxAmountExchange} (حداکثر) `}}</span>

        </div>
        </div>
        <div class="text" :key="coin + 'sell'">

        <div class="minmax">  <span>1 {{  `${$coins[coin].persianName}  (${$coins[coin].code}) :` }} </span>  <span>             {{ $toLocal(data.unitPrice, 0) }}
               {{this.toman ? 'تومان': 'تتر'}} </span></div>
        </div>
   <button class="blue-btn" v-if="buy" @click="placed = true" :disabled="!!buyReadOnly">{{ !!buyReadOnly?buyReadOnly:'معامله سریع' }}</button>
        <button class="blue-btn" v-else @click="placed = true" :disabled="!!sellReadOnly">{{!!sellReadOnly?sellReadOnly: 'معامله سریع'}}</button>

      </div>
      <place-order
          v-if="placed"
          @close="placed = false"
          @accept="sendData"
          :unitPrice="data.unitPrice"
          :totalPrice="data.totalPrice"
          :amount="data.amount"
          :coin="data.destinationCoin"
          :type="this.buy"
      />
      <ex-modal
          v-if="success"
          :unitprice="data.unitPrice"
          :totalprice="data.totalPrice"
          :ordertype="data.orderType"
          :amount="data.amount"
          @closeModal="success = false"
      />
    </div>
  </transition>
</template>

<script>
import PayOtcModal from "./Modals/pay-otc-modal";
import ResiveOtcModal from "./Modals/resive-otc-modal";
import PlaceOrder from "@/views/tools/Modals/PlaceOrder";
import exModal from "@/views/tools/Modals/exModal";
import { Loop } from "@/lib/reuseableFunction";


export default {
  name: "the-otc",
  components: {ResiveOtcModal, PayOtcModal

  ,PlaceOrder, exModal},
  watch:{
    'coin'(){
      this.getPrice()
      this.getWallets()
      this.MinMaxAmount()
    },
    'toman'(){
      this.getPrice()
      this.getWallets()
    },
    'maximum'(){

        this.calculating= true;
        this.data.totalPrice = this.$toLocal(this.BuywalletBalance.credit, this.$decimal[this.toman?'TOMAN': 'TETHER'])
        this.loop.stop()
        this.calcAmount()

    },
    'maximumAmount'(){
      this.calculating=true;
      this.data.amount = this.$toLocal(this.credit, this.$decimal[this.coin])
      this.loop.stop()
      this.calcAmount()
    }
  },
  data() {
    return {
      payModal: false,
      placed:false,
      buy:true,
      resiveModal:false,
      payment:'TOMAN',
      items:{name:'تومان', relationName:'TMN', logo:'TOMAN'},
      resItem:{ name:'بیتکوین' , coin:'BITCOIN'  , code:'BTC'},
      temptData: {},
      isTyping: false,
      disable: true,
      loop: undefined,
      sellAmount: "",
      coin: "BITCOIN",
      credit: "",
      walletBalance: {},
      loading: false,
      prices: "",
      beebitexWallet: true,
      netDrop: false,
      selected_net: "",
      nets: [],
      coins: [],
      txIdIsNeeded: false,
      totalPrice: "",
      exModal: false,
      success: false,
      BuywalletBalance: "",
      SellwalletBalance: "",
      minAmountExchange: "",
      maxAmountExchange: "",
      data: {
        marketType: "TRON_TOMAN",
        amount: null,
        sourceCoin: "TOMAN",
        destinationCoin: "TRON",
        orderType: "EXCHANGE_BUY",
        // tokenType: "",
        // destinationWallet: "",
        unitPrice: null,
        totalPrice: null,
        dollar: null,
        wage: 0.3,
      },
      placeholderCrypto: "دریافت میکند",
      placeholderToman: "می پردازد",
      amount: "",
      drop: false,
      modal: false,
      alive: true,
      toman: true,
      wallet: [{}],
      fromAmount: true,
      calculating: false,
      maximum:false,
      maximumAmount:false,

    }
  },


  computed: {
    sellReadOnly() {
      let error = "";
      if (!this.$A2N(this.data.amount)) {
        error = "مقدار ارز اجباری است";
        // this.disableSell = true
      } else if (this.$S2N(this.data.amount) < this.minAmountExchange) {
        error = "حداقل مقدار رعایت نشده";
        // this.disableSell = true
      } else if (
          (this.buy &&
              this.$S2N(this.data.totalPrice) > this.BuywalletBalance.credit) ||
          (!this.buy && this.$S2N(this.data.amount) > this.walletBalance.credit)
      ) {
        error = "مقدار بیش از موجودی شماست";
        // this.sellAmount = 'مقدار بیش از موجودی شماست'
        // this.disableSell = true
      } else if (this.$S2N(this.data.amount) > this.maxAmountExchange) {
        error = "حداکثر مقدار رعایت نشده";
        // this.sellAmount = 'حداکثر مقدار رعایت نشده'
        // this.disableSell = true
      }

      // else if (this.calculating) {
      //   error = "لطفا صبر کنید ...";
      // }
      return error;
      //  else {
      //     this.disableSell = false
      //     this.sellAmount = ''
      // }
    },

    buyReadOnly() {
      let error = "";
      if (!this.$A2N(this.data.amount)) {
        error = "مقدار ارز اجباری است";
      } else if (this.$A2N(this.data.amount) < this.minAmountExchange) {
        error = "حداقل مقدار رعایت نشده";
      }
      else if (this.payment ==this.coin){
        error ='ارز و مقدار دریافتی باید متفاوت باشد'
      }




      else if (
          this.$A2N(this.data.totalPrice) > this.BuywalletBalance.credit
      ) {
        error = "مقدار بیش از موجودی شماست";
      } else if (this.$A2N(this.data.amount) > this.maxAmountExchange) {
        error = "حداکثر مقدار رعایت نشده";
      } else if (!this.beebitexWallet) {
        if (this.data.destinationWallet == "") {
          error = " آدرس کیف پول اجباری است ";
        } else if (this.data.tokenType == "") {
          error = "انخاب شبگه اجباری است";
        }
      } else if (this.calculating) {
        error = "لطفا صبر کنید ...";
      }

      return error;
    },
  },
  methods: {
    async setMaxAmount() {
      await this.calcAmount()
      this.maximumAmount= true;
      this.data.amount = this.$toLocal(this.credit, this.$decimal[this.coin])

    },
    async setMax(){
      await this.calcAmount()
      this.maximum = true
      this.data.totalPrice = this.$toLocal(this.BuywalletBalance.credit, this.$decimal[this.toman?'TOMAN': 'TETHER'])


    },
    choiseCoin(value) {
      this.items = value;

      this.payment = value.value
      console.log(this.payment);
      value.value =='TOMAN' ? this.toman = true : this.toman = false
      console.log(this.toman)
      this.payModal = false
    },
    resivecoin(value){
      this.resItem = value
      this.resiveModal = false
      console.log(value.coin)
      this.coin = value.coin
      this.data.destinationCoin = value.coin
      console.log( 'coin',this.coin)
    },





    async unitFun() {
      this.data.totalPrice = "";





      if (this.loop) {





        this.loop.stop();
      }
      this.toman = !this.toman;
      // $emit('changeUnit',toman);
      // calcTotalPrice();calcAmount();
      await this.tomanTetherWallet();
      this.beforeLoop();
    },
    async inputsFun(e) {
      this.calculating = true;
      if (e === "amount") {
        this.data.amount = this.$toLocal(
            this.data.amount,
            this.$decimal[this.coin]
        );
      } else {

        if (this.maximum){
          this.calculating =true
          this.data.totalPrice = this.$toLocal(
              this.data.totalPrice,
              this.$decimal["TOMAN"]

          );

          this.calcAmount()
        }

        else if(this.maximumAmount){
          this.calculating =true
          this.data.amount = this.$toLocal(
              this.data.amount,
              this.$decimal["TETHER"]

          );


        }





        this.data.totalPrice = this.$toLocal(
            this.data.totalPrice,
            this.$decimal["TOMAN"]
        );
      }

      this.fromAmount = e === "amount";
      if (this.loop) {
        this.loop.stop();
      }
      const temp = this.data[e];
      await this.$sleep(500);
      if (temp === this.data[e]) {
        this.beforeLoop();
      }
    },
    //
    // async totalPriceFun() {
    //   // this.calcAmount();
    //   // this.sellReadOnly()
    //   // this.data.totalOfAll = this.$toLocal(this.data.totalPrice * this.data.amount, this.$decimal[this.toman ? 'TOMAN' : 'TETHER'])
    //   this.calculating = true;
    //   let total = this.data.amount * this.data.totalPrice * this.data.dollar;
    //   this.data.totalPrice = this.$toLocal(total, 1);
    // },
    // amountFun() {

    //     this.calcTotalPrice()
    //     this.data.amount = this.$toLocal(this.data.amount)
    //     this.sellReadOnly()
    // },
    checkModal() {
      if (this.buy) {
        this.data.marketType =
            this.coin + "_" + (this.toman ? "TOMAN" : "TETHER");
        // this.data.destinationCoin = this.coin;
        this.data.orderType = "EXCHANGE_BUY";
        this.exModal = true;
      } else {
        this.data.marketType =

            this.coin + "_" + (this.toman ? "TOMAN" : "TETHER");
        // this.data.destinationCoin = this.coin;
        this.data.orderType = "EXCHANGE_SELL";
        this.exModal = true;
      }
    },
    async sendData() {
      this.placed = false;
      this.temptData = JSON.parse(JSON.stringify(this.data));
      this.temptData.amount = this.$S2N(this.temptData.amount);

      this.temptData.totalPrice = this.$S2N(this.temptData.totalPrice);
      this.temptData.unitPrice = this.$S2N(this.temptData.unitPrice);
      this.exModal = false;
if(this.state.token) {
  if (this.buy) {
    this.state.loading = true;
    this.temptData.orderType = 'EXCHANGE_BUY'
    this.temptData.marketType = this.coin + "_" + (this.toman ? "TOMAN" : "TETHER");
    await this.$axios.post("/exchange/buy", this.temptData);
    this.success = true;
  } else {
    delete this.temptData.destinationWallet;
    delete this.temptData.tokenType;
    this.temptData.orderType = "EXCHANGE_SELL";
    this.temptData.marketType = this.coin + "_" + (this.toman ? "TOMAN" : "TETHER");
    this.data.orderType = "EXCHANGE_SELL";
    this.state.loading = true;
    await this.$axios.post("/exchange/sell", this.temptData);
    this.success = true;
    this.getWallets();
    this.tomanTetherWallet();
    this.state.loading = false;
  }
}else{
  this.$router.push({
    name: "Login"
  });

}
    },
    //getting wallets
    async getWallets() {
     if (this.state.token){
       this.state.loading = true;
       const [res] = await this.$http.get(
           `/wallets/customer-addresses?walletType=EXCHANGE`,
           {
             params: {
               coins: `${this.coin}`,
             },
           }
       );
       if (res) {
         this.walletBalance = res[this.coin];
         this.credit = this.walletBalance.credit;
       }
       this.state.loading = false;
     }
     else {
       return
     }
    },
    async getPrice() {

      const res = await this.$axios.get(
          // "coins/exchange-price/"+ this.toman? 'usd' : 'usdt' +"?includeWeeklyChange=false&destCoinSymbol=" +
          //   this.coin

          `coins/exchange-price/${this.toman ? 'usd' : 'usdt'}?includeWeeklyChange=false&destCoinSymbol=${this.coin}`
      );
      this.prices = res;
      this.data.unitPrice = this.prices.find(
          (a) => a.destCoinSymbol == this.coin
      )[this.buy ? "buyPrice" : "sellPrice"];
      if (this.fromAmount) {
        this.calcTotalPrice();
      } else {
        this.calcAmount();
      }
// this.beforeLoop()
      this.calculating = false;

    },
    async tomanTetherWallet() {
   if(this.state.token){
     // this.loading = true
     const [res2] = await this.$http.get(

         `/wallets/customer-addresses?walletType=EXCHANGE&coins=${this.toman? "TOMAN" : "TETHER"}`
     );
     // console.log(res2)
     if (res2) {
       this.BuywalletBalance = this.toman?res2["TOMAN"]:res2["TETHER"];

     }
     this.beforeLoop()
   }
   else {}
      // this.loading = false
    },
    calcTotalPrice() {
      this.data.totalPrice = this.$toLocal(
          this.$S2N(this.data.amount) * this.$S2N(this.data.unitPrice),
          this.$decimal[this.toman ? "TOMAN" : "TETHER"]
      );
    },
    calcAmount() {

      // this.buy?
      // this.data.amount = this.$toLocal(
      //     this.$S2N(this.data.totalPrice) / this.$S2N(this.data.unitPrice),
      //     this.$decimal[this.coin]
      // ) :
      //     this.data.amount = this.credit
      //     this.data.totalPrice =this.$S2N(this.data.unitPrice ) * this.$S2N(this.data.amount)


   if(this.buy){
     this.data.amount =this.$toLocal(this.$S2N(this.data.totalPrice)/ this.$S2N(this.data.unitPrice),
         this.$decimal[this.coin])
   }

   if(!this.buy){
     // this.data.amount = this.credit
     this.data.totalPrice =this.$S2N(this.data.unitPrice ) * this.$S2N(this.data.amount)
   }







    },





    async getCoins() {
      this.state.loading = true;
      const res = await this.$axios.get("/coins/details");
      this.coins = res.content.filter((name) => name.coin !== "TOMAN");
      this.state.loading = false;
    },

    titlesclick() {
      if (this.buyTtile) {
        return true;
      } else {
        this.buyTtile = true;
        this.sellTitle = false;
      }
    },
    async selectedCoin(value) {
      this.data.amount = 0;
      this.coin = value.destCoinSymbol;
      await this.getWallets();
      // this.getNets()
      this.beforeLoop();
    },
    MinMaxAmount() {
      this.minAmountExchange = this.coins.find(
          (a) => a.coin == this.coin
      ).minAmountExchange;
      this.maxAmountExchange = this.coins.find(
          (a) => a.coin == this.coin
      ).maxAmountExchange;
    },
    beforeLoop() {
      this.state.loading = false;
      this.calculating = true;
      if (this.loop) {
        this.loop.stop();
      }
      this.loading = true;
      if (this.state.loop) {
        this.loop = new Loop(
            this.getPrice,
            5000,
            "getPrice" + (this.toman ? "Toman" : "Tether")
        );
        this.loop.start();
      } else {
        this.getPrice();
      }
    },

  },



  async mounted() {
    await this.getWallets();
    this.getPrice();
    await this.getCoins();
    await this.tomanTetherWallet();
    await this.MinMaxAmount();
    this.beforeLoop();

this.data.destinationCoin = 'BITCOIN'
    this.coin = this.coins[0].coin;
    // this.data.marketType = `${this.coin}_TOMAN`;

  },
  beforeDestroy() {
    if (this.loop) {
      this.loop.stop();
    }
  },


}
</script>

<style lang="scss" scoped>
.ex-input{
  width: 100%;
  color: white;
  text-align: left;
  margin-bottom:1px;
}
.max{
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  .ex-input{
    width: 80%;
    color: white;
    text-align: left;
    margin-bottom:1px;
  }
  .btn{
    width: 20%;
height: 25px;
    align-self: center;



  }
}
.minmax{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {

  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}


.mirror{
  transform: rotateZ(180deg);
}


.transfer-logo {
  transition: transform 1s ease;
  //margin-top: 10px;
  //display: flex;
  //justify-content: center;
  //width: 100%;


}





.pay{
  display: flex;
  flex-direction: column;
  //gap: 10px;
}
.otc-box {
  background-image: url("../../assets/backgrounds/bgnoiseeee.png");
  background-size: auto;
  background-position: center;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;

  .value-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      color: rgba(140, 133, 133, 1);
      font-size: 14px;
    }
  }

  .pay-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 50px;

    .pay-text {
      font-size: clamp(12px, 1.5vw, 20px);
      color: #FFFFFF;
    }

    .pay-type {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      font-size: clamp(12px, 1vw, 16px);
      color: #FFFFFF;
      cursor: pointer;
    }
  }

  .change-icon {
    display: flex;
    justify-content: center;
    height: 40px;
    align-items: center;
  }

  .submit {
    width: 100%;
    color: rgba(140, 133, 133, 1);
    font-size: 12px;
    display: flex;
    flex-direction: column;
    margin-top: 60px;

    .text {
      display: flex;
      width: 100%;
      justify-content: end;
      margin-bottom: 12px;
    }
  }

  .resive-value {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #FFFFFF;
    line-height: 2.5;

    span {
      color: rgba(140, 133, 133, 1);
      font-size: 14px;
    }
  }

}
</style>